// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2WBZb","errorLogs":"styles_errorLogs__2EumH"};